import { formatISO, parseISO, } from 'date-fns';
/**
 * @param {string} apiDateTimeString
 */
export function apiDateTimeStringToDate(apiDateTimeString) {
    return parseISO(apiDateTimeString);
}
export function dateToApiDateTimeString(date) {
    return formatISO(date);
}
export function dateToApiDateString(date) {
    return formatISO(date, { representation: 'date' });
}
